module.exports = __webpack_public_path__ + "img/hq.bd36acc.svg";